/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Access_InactiveInputs */

const fr_membership_access_inactive = /** @type {(inputs: Membership_Access_InactiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inactif`)
};

/**

* @param {Membership_Access_InactiveInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_access_inactive = /** @type {((inputs?: Membership_Access_InactiveInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Access_InactiveInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_access_inactive(inputs)
});